import { render, staticRenderFns } from "./map-box.vue?vue&type=template&id=015156dc&"
import script from "./map-box.vue?vue&type=script&lang=js&"
export * from "./map-box.vue?vue&type=script&lang=js&"
import style0 from "./map-box.vue?vue&type=style&index=0&id=015156dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports